module.exports = __webpack_public_path__ + "public/img/Desktop-3.8efb7abf.png";